import { CSSProperties } from "react";

export const CreateChallengeStyles: Record<string, CSSProperties> = {
    container: {
      position: 'relative',
      flexDirection: "row",
      width: "100%",  
      flexWrap: "nowrap"
    },
    trashContainer : {
      marginLeft: 16,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 30,
      height: 30,
      backgroundColor: 'red',
      borderRadius: 30,
      cursor: 'pointer',
    },
    toggleContainer: {
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: 24,
      display: 'flex'
    },
    toggleText: {
      fontSize: 12,
      color: "#2F2F2F",
      marginLeft: 8,
      fontWeight: 500
    },
    inputContainer: {
      marginBottom: 16,
    },
    flag: {
      margin: 8,
      height: 22,
      width: 22,
      borderRadius: 22,
      cursor: 'pointer',
    },
    selectedFlag: {
      width: 32,
      height: 32,
    },
    flagsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 20,
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    image: {
      width: 40,
      height: 40,
      marginRight: 16,
    },
    dropZone: {
      width: 360,
      minHeight: 200,
      border: '1px dashed #4054CC',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#4054CC',
      cursor: 'pointer',
    },
    label: {
      height: 32,
      border: '1px dashed #4054CC',
      borderRadius: 16,
      color: '#4054CC',
      paddingLeft: 8,
      paddingRight: 8,
      display: 'flex',
      alignItems: 'center',
      marginRight: 8,
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 8,
    },
    section: {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      padding: 16,
    },
    tab: {
      padding: 4,
      cursor: 'pointer',
    },
    selectedTab: {
      backgroundColor: 'white',
      fontWeight: 'bold',
    },
  };


// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/styles.tsx